import messages from '../../messages';

export const SSNCODE_REGEX = /^\d{5}$/;
import { PROFESSION_TYPES } from '../../../register/data/constants';

const validateSsncode = (value, professionType, formatMessage) => {
  let fieldError = '';
  const trimmedValue = value?.trim() || '';

  if (professionType !== PROFESSION_TYPES.TEACHER) {
    return '';
  }

  if (!trimmedValue) {
    fieldError = formatMessage(messages['empty.ssncode.field.error']);
  } else if (!SSNCODE_REGEX.test(trimmedValue)) {
    fieldError = formatMessage(messages['ssncode.validation.message']);
  }

  return fieldError;
};

export default validateSsncode;
